export default {
      id: "color_wgs_clock-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#color_wgs_clock",
      toString: function () {
        return this.url;
      }
    }